import HexController from 'controllers/hex_controller';

export default class extends HexController {
  static targets = ['parameter', 'parameterName', 'value', 'toggle', 'toggleInput', 'remove'];
  static values = {
    parameters: Array,
    parameterId: Number,
    value: String,
    isToggle: Boolean
  };

  get parameter() {
    return this.parametersValue.find(p => p.id === this.parameterIdValue);
  }

  connect() {
    this.parameterTarget.value = this.parameterIdValue;
    this.parameterNameTarget.value = this.parameter?.name || '';
  }

  changeParameter(e) {
    e.preventDefault();
    this.parameterIdValue = e.target.value;
    while (this.valueTarget.options.length > 0) {
      this.valueTarget.remove(0);
    }
    if (this.parameterIdValue) {
      Object.values(this.parameter.values).map(v => this.valueTarget.options.add(new Option(v, v)));
      [this.valueTarget, this.toggleTarget, this.removeTarget].forEach(t => t.classList.remove('hidden'));
      this.parameterNameTarget.value = this.parameter.name;
    } else {
      this.valueTarget.options.add(new Option(this.t('Select a parameter'), ''));
      [this.valueTarget, this.toggleTarget, this.removeTarget].forEach(t => t.classList.add('hidden'));
      this.parameterNameTarget.value = '';
    }
    this.valueTarget.value = this.valueTarget.options[0].value;
    this.valueValue = this.valueTarget.options[0].value;
  }

  toggle(e) {
    e.preventDefault();
    this.isToggleValue = !this.isToggleValue;
    this.toggleInputTarget.value = this.isToggleValue;
    this.toggleTarget.textContent = this.isToggleValue ? 'is' : 'is not';
  }

  updateWithUsedParameters(usedParameters) {
    for (let i = 0; i < this.parameterTarget.options.length; i++) {
      const option = this.parameterTarget.options[i];
      if (!option.selected && usedParameters.has(parseInt(option.value))) {
        option.classList.add('hidden');
      } else {
        option.classList.remove('hidden');
      }
    }
  }
}